<template>
  <div class="cmp_upload_file">
    <section>
      <i class="el-icon-upload2"></i>
      <input class="inputFile" type="file" @change="fileChange" />
    </section>
    <p>
      上传我的练习图片
    </p>
  </div>
</template>

<script>
import ossUtil from "@/assets/js/ossUtil.js";
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  methods: {
    fileChange(e) {
      if (!e.target.files) {
        return;
      }
      if (e.target.files.length) {
        this.loadingCount++;
        ossUtil
          .upload(e.target.files[0], {}, true)
          .then((res) => {
            this.$emit("uploadFileChange", {
              url: res.url,
              fileName: res.originalName,
              createTime: res.createTime,
            });
          })
          .catch((err) => {
            this.$message.error("文件上传失败");
            this.$ajaxError(err);
          })
          .finally(() => {
            this.loadingCount--;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.cmp_upload_file {
  width: 210px;
  section {
    height: 118px;
    background: #edf5fb;
    border-radius: 6px;
    border: 1px dashed #19a4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    i {
      color: #00a7ff;
      font-size: 40px;
    }
    .inputFile {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      cursor: pointer;
      left: 0;
      top: 0;
    }
  }
  p {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 10px 0;
  }
}
</style>
